import _axios from '../../apiClient'

export function getTipotalle() {
  return _axios
    .get(`/api/Articulo`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function saveArticulo(payload) {
  return _axios
    .post(`/api/Articulo/Save`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function saveArticuloGenerico(payload) {
  return _axios
    .post(`/api/Articulo/SaveGenerico`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function borrarArticulo(payload) {
  return _axios
    .post(`/api/Articulo/DeleteArticulo`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function borrarArticuloFromCatalogo(payload) {
  return _axios
    .post(`/api/Articulo/DeleteFromCatalogo`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}
export function agregarArticuloToCatalogo(payload) {
  return _axios
    .post(`/api/Articulo/AddToCatalogo`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}
export function saveImagenArticulo(payload) {
  let newFile = payload.currentFile
  let formData = new FormData()
  formData.append('file', newFile)

  return _axios
    .post(
      `/api/Articulo/SaveImagen?idTemporal=${payload.idTemporal}`,
      formData,
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function saveImagenArticuloRecorte(payload) {
  let newFile = payload.file
  let formData = new FormData()
  formData.append('file', newFile)

  return _axios
    .post(
      `/api/Articulo/SaveImagenRecorte?idTemporal=${payload.idTemporal}`,
      formData,
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function saveImagenArticuloTallecolor(payload) {
  let newFile = payload.currentFile
  let formData = new FormData()
  formData.append('file', newFile)

  return _axios
    .post(
      `/api/Articulo/SaveImagenTalleColor?idTemporal=${payload.idTemporal}`,
      formData,
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function saveImagenTalleColorRecorte(payload) {
  let newFile = payload.file
  let formData = new FormData()
  formData.append('file', newFile)

  return _axios
    .post(
      `/api/Articulo/SaveImagenTalleColorRecorte?idTemporal=${payload.idTemporal}`,
      formData,
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getArticuloCompleto(payload) {
  return _axios
    .get(
      `/api/Articulo/GetArticuloCompleto`,
      { params: payload },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getListadoArticulos(payload) {
  return _axios
    .get(
      `/api/Articulo/GetListadoArticulo`,
      {
        params: {
          nombre: payload.Nombre,
          cod: payload.Codigo,
          idSuperRubro: payload.idSuperRubro,
          idRubro: payload.idRubro,
          idSubRubro: payload.idSubRubro,
          page: payload.page,
          pagesize: payload.pagesize,
        },
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getListadoEntradas(payload) {
  return _axios
    .get(
      `/api/Articulo/GetListadoEntradas`,
      {
        params: {
          nombre: payload.Nombre,
          cod: payload.Codigo,
          idSuperRubro: payload.idSuperRubro,
          idRubro: payload.idRubro,
          idSubRubro: payload.idSubRubro,
          page: payload.page,
          pagesize: payload.pagesize,
          idCatalogo: payload.idCatalogo,
        },
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getListadoArticulosAusentesEnCatalogo(payload) {
  return _axios
    .get(
      `/api/Articulo/GetListadoArticulosNoIncluidos`,
      {
        params: {
          nombre: payload.Nombre,
          cod: payload.Codigo,
          idSuperRubro: payload.idSuperRubro,
          idRubro: payload.idRubro,
          idSubRubro: payload.idSubRubro,
          page: payload.page,
          pagesize: payload.pagesize,
          idCatalogo: payload.idCatalogo,
        },
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getArticuloImagen(payload) {
  return _axios
    .get(
      `/api/Articulo/GetArticuloImagen`,
      { params: payload },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getArticuloImagenes(payload) {
  //A utilizar en el listado de Articulos

  return _axios
    .get(
      `/api/Articulo/GetArticuloImagenes`,
      { params: payload },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function eliminarImagenArticulo(payload) {
  return _axios
    .post(`/api/Articulo/EliminarImagenArticulo`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getStockImagen(payload) {
  return _axios
    .get(
      `/api/Articulo/GetTalleColorImagen`,
      { params: payload },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}
